export function leadSubmitted(listingId) {
  return listingId && (
    MOVE.SRP && MOVE.SRP.SubmittedLeads && MOVE.SRP.SubmittedLeads.getListings() || {}
  )[listingId];
}



// WEBPACK FOOTER //
// ./quick_view/components/leads/base.js